import { MenuOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Layout, Row, Space, theme } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import LangSwitcher from '@client/components/LangSwitcher';
import { ProfileMenu } from '@client/components/ProfileMenu';
import { SystemInfo } from '@client/components/system/Info';
import ThemeSwitcher from '@client/components/ThemeSwitcher';
import { useAuth } from '@client/hooks/useAuth';
import { useMenuToggle } from '@client/store/menu.store';
import { ERoutePaths } from '@client/types';

import styles from './layout.module.less';

const { Header } = Layout;

export const LayoutHeader: React.FC = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();
  const { menuOpened, setMenuOpened } = useMenuToggle();

  const navigateToLogin = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    navigate(ERoutePaths.LOGIN);
  };

  return (
    <Header style={{ background: colorBgContainer }} className={styles.header}>
      <Row>
        {user ? (
          <Col span={1}>
            <Button
              color={menuOpened ? 'primary' : 'default'}
              variant="outlined"
              icon={<MenuOutlined />}
              onClick={() => setMenuOpened(!menuOpened)}
            />
          </Col>
        ) : null}
        <Col offset={1} span={user ? 4 : 5}>
          <Space align="center" size="small">
            <img src="/logo-icon.png" alt="iSubscribe" width="24" height="24" />
            <span>iSubscribe.me</span>
          </Space>
        </Col>
        <Col span={18}>
          <Flex gap="middle" justify="space-between" align="center">
            <SystemInfo />
            <Flex gap="small" align="center">
              <ThemeSwitcher />
              <LangSwitcher />
              {user ? (
                <ProfileMenu />
              ) : (
                <Button variant="link" onClick={navigateToLogin}>
                  {t('actions.login')}
                </Button>
              )}
            </Flex>
          </Flex>
        </Col>
      </Row>
    </Header>
  );
};
